import { Package, Bookmark, Copy, Sparkles } from "lucide-react";

// Mirrors packages/shared/src/schemas/segment.ts → SegmentType (TS enum).
// 0=Prebuilt, 1=Saved Segment, 2=Lookalike, 3=AI generated.
export const SEGMENT_TYPE = Object.freeze({
  PREBUILT: 0,
  SAVED_SEGMENT: 1,
  LOOKALIKE: 2,
  AI_GENERATED: 3,
});

export const SEGMENT_TYPE_LABELS = Object.freeze({
  [SEGMENT_TYPE.PREBUILT]: "Prebuilt",
  [SEGMENT_TYPE.SAVED_SEGMENT]: "Saved Audience",
  [SEGMENT_TYPE.LOOKALIKE]: "Lookalike",
  [SEGMENT_TYPE.AI_GENERATED]: "AI generated",
});

export const SEGMENT_TYPE_ICONS = Object.freeze({
  [SEGMENT_TYPE.PREBUILT]: Package,
  [SEGMENT_TYPE.SAVED_SEGMENT]: Bookmark,
  [SEGMENT_TYPE.LOOKALIKE]: Copy,
  [SEGMENT_TYPE.AI_GENERATED]: Sparkles,
});

export const DEFAULT_SEGMENT_TYPE = SEGMENT_TYPE.SAVED_SEGMENT;

export const getSegmentTypeIcon = (type) =>
  SEGMENT_TYPE_ICONS[type] ?? SEGMENT_TYPE_ICONS[DEFAULT_SEGMENT_TYPE];

export const getSegmentTypeLabel = (type) =>
  SEGMENT_TYPE_LABELS[type] ?? SEGMENT_TYPE_LABELS[DEFAULT_SEGMENT_TYPE];
